module.exports = __webpack_public_path__ + "static/img/76-2.5fa48d9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/76-2.jpg
// module id = +OZA
// module chunks = 0